"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DeckFilterInput_1 = __importDefault(require("../DeckFilterInput"));
var STARRED_LABEL = 'Starred cards';
var RETIRED_LABEL = 'Retired cards';
var NEW_LABEL = 'New cards';
var DeckFilterInputContainer = function (_a) {
    var deck = _a.deck;
    var hasStarredCards = false;
    var hasRetiredCards = false;
    deck.cards.forEach(function (card) {
        if (card.starred) {
            hasStarredCards = true;
        }
        if (card.retired) {
            hasRetiredCards = true;
        }
    });
    function handleChange(event, value) {
        var filterNew = false;
        var filterStarred = false;
        var filterRetired = false;
        var selectedCategory = '';
        var selectedSubcategories = [];
        value.forEach(function (option) {
            if (option.type === 'category') {
                selectedCategory = option.id;
            }
            else if (option.type === 'subcategory') {
                selectedSubcategories.push(option.id);
            }
            else if (option.type === 'new') {
                filterNew = true;
            }
            else if (option.type === 'starred') {
                filterStarred = true;
            }
            else if (option.type === 'retired') {
                filterRetired = true;
            }
        });
        deck.setFilterCategory(selectedCategory);
        deck.setFilterSubcategories(selectedSubcategories);
        deck.toggleFilterNew(filterNew);
        deck.toggleFilterStarred(filterStarred);
        deck.toggleFilterRetired(filterRetired);
    }
    var autocompleteValue = [];
    if (deck.filterStarred) {
        autocompleteValue.push({
            id: STARRED_LABEL,
            name: STARRED_LABEL,
            type: 'starred',
        });
    }
    if (deck.filterNew) {
        autocompleteValue.push({
            id: NEW_LABEL,
            name: NEW_LABEL,
            type: 'new',
        });
    }
    if (deck.filterRetired) {
        autocompleteValue.push({
            id: RETIRED_LABEL,
            name: RETIRED_LABEL,
            type: 'retired',
        });
    }
    if (deck.filterCategory) {
        autocompleteValue.push({
            type: 'category',
            id: deck.filterCategory,
            name: deck.filterCategory,
        });
    }
    if (deck.filterSubcategories.length) {
        autocompleteValue = __spreadArray(__spreadArray([], __read(autocompleteValue)), __read(deck.filterSubcategories.map(function (subcategory) { return ({
            id: subcategory,
            name: subcategory,
            type: 'subcategory',
        }); })));
    }
    var options = __spreadArray(__spreadArray([], __read(deck.categories.map(function (category) { return ({
        name: category,
        id: category,
        type: 'category',
        group: 'Categories',
    }); }))), __read(deck.subcategories.map(function (subcategory) { return ({
        type: 'subcategory',
        name: subcategory,
        id: subcategory,
        group: 'Subcategories',
    }); })));
    if (hasRetiredCards) {
        options.unshift({
            name: RETIRED_LABEL,
            id: RETIRED_LABEL,
            type: 'retired',
        });
    }
    if (hasStarredCards) {
        options.unshift({
            name: STARRED_LABEL,
            id: STARRED_LABEL,
            type: 'starred',
        });
    }
    if (deck.notStartedCardsCount) {
        options.unshift({
            name: NEW_LABEL,
            id: NEW_LABEL,
            type: 'new',
        });
    }
    return (react_1.default.createElement(DeckFilterInput_1.default, { options: options, onChange: handleChange, value: autocompleteValue }));
};
exports.default = DeckFilterInputContainer;
//# sourceMappingURL=DeckFilterInputContainer.js.map